export const tr = {
    'select-empty': 'Boş alanlar'
};
